import { styled } from "@mui/material";

export const ImportantText = styled("span")((props) => ({
  fontWeight: props.theme.typography.fontWeightRegular,
}));
